
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import GetAppIcon from "@mui/icons-material/GetApp";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import {
  Autocomplete, Box, Checkbox, Chip,
  CircularProgress, Divider,
  FormControl,
  InputLabel, Link, ListItemText, MenuItem, OutlinedInput, Select, Skeleton, Tab,
  Tabs, TextField, Tooltip,
  tooltipClasses, Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import Layout from "../../components/layout/Layout";
import { apiDematHoldingsDownload, apiDematTableInvestors, apiGetCorpActionFileLog, apiGetDematHoldings, apiGetIsinDetails, getDematMasterTable, getOpportunitySimple, getPartners } from "../../utils/api/api";
import { BASE_URL, CLOSED_SCHEMES, CREDITED, ESCROW, GENERATED, OPEN_SCHEMES, PENDING, RECORD_DISPLAY_LIMIT, SNACKBAR_ERROR } from "../../utils/constants/constants";
import { isSubAdmin } from "../../utils/StringUtil";
import CorporateActionDialog from "./CorporateActionDialog";
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    backgroundColor: theme.palette.common.white,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    border: "1px solid #000",
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1),
  },
}));

export const DematInvestors = ({ dematInvestorList, showTableLoading }) => {
  return (
    <div
      className="d-flex flex-column overflow-y-auto"
      style={{ minWidth: "300px", maxHeight: "500px" }}
    >
      {showTableLoading ? (
        <CircularProgress />
      ) : (
        <>
          {dematInvestorList?.map((investor, index) => (
            <div className="d-flex align-items-center px-2 py-1" key={index}>
              <AccountCircleIcon color="primary" fontSize="large" />
              <div className="d-flex flex-grow-1 flex-column ms-2">
                <div>
                  <span className="fs-med-medium text-dark">
                    {investor?.fullName}
                  </span>
                  <span className="fs-med-medium ms-1">
                    <Chip
                      label={investor?.dematCreditDate ? "CREDITED" : "PENDING"}
                      size="small"
                      color={investor?.dematCreditDate ? "success" : "warning"}
                      variant="outlined"
                      sx={{
                        fontSize: "0.7rem",
                        height: "20px",
                        padding: "4px",
                      }}
                    />
                  </span>
                </div>
                <span className="fs-small-regular text-dark">
                  {investor?.email}
                </span>
                <span className="fs-small-medium text-dark">
                  {investor?.invCode}
                </span>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

const DematMaster = () => {
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalIsinRecords, setTotalIsinRecords] = useState(0);
  const [dematList, setDematList] = useState([]);
  const [dematDataList, setDematDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [dematInvestors, setDematInvestors] = useState([]);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [filterPartner, setFilterPartner] = useState([]);
  const [filterScheme, setFilterScheme] = useState([]);
  const [filterIsinScheme, setFilterIsinScheme] = useState([]);
  const [filterSchemeList, setFilterSchemeList] = useState([]);
  const [filterIsinSchemeList, setFilterIsinSchemeList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const userType = process.env.REACT_APP_USER_TYPE;
  const { enqueueSnackbar } = useSnackbar();
  const [isInList, setIsInList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isinSearchTerm, setisinSearchTerm] = useState("");
  const [isInStatus, setIsInStatus] = useState("ALL");
  const [holdingsList, setHoldingsList] = useState([]);
  const [persistentSchemeFilters, setPersistentSchemeFilters] = useState([]);
  const [schemeFilterLoading, setSchemeFilterLoading] = useState(false);
  const [filterDematStatus, setFilterDematStatus] = useState("all");
  const [schemePage, setSchemePage] = useState(1);
  const [hasMoreSchemes, setHasMoreSchemes] = useState("");
  const schemeListboxRef = useRef();
  const loaderRef = useRef(null);
  const [initialTabLoad, setInitialTabLoad] = useState(true);
  const [schemeSearchTerm, setSchemeSearchTerm] = useState("");
  const [isSearchingScheme, setIsSearchingScheme] = useState(false);
  const scrollPreservationRef = useRef({
    position: 0,
    isUpdating: false
  });
  const lastDematHoldingsParams = useRef(null);
  const lastFilterSchemesParams = useRef(null);
  const filterChangeRef = useRef(false);

  const schemeAutocompleteRef = useRef(null);
  const schemeInputPositionRef = useRef(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openCorporateAction, setOpenCorporateAction] = useState(false);

  const [corpActionFileList, setCorpActionFileList] = useState([]);
  const [totalCorpActionRecords, setTotalCorpActionRecords] = useState(0);
  const [corpActionPage, setCorpActionPage] = useState(1);
  const [isCorpActionLoading, setIsCorpActionLoading] = useState(false);

  const toggleCorporateAction = (shouldRefresh = false) => {
    if (openCorporateAction && shouldRefresh && tabIndex === 3) {
      setCorpActionPage(1);
      getCorpActionFileLog(1);
    }

    setOpenCorporateAction(!openCorporateAction);
    if (menuAnchorEl) {
      setMenuAnchorEl(null);
    }
  };
  const debouncedSearchTab1 = useCallback(
    _.debounce((searchValue) => {
      setSearchTerm(searchValue);
    }, 100),
    []
  );

  const debouncedSearchTab2 = useCallback(
    _.debounce((searchValue) => {
      setisinSearchTerm(searchValue);
    }, 100),
    []
  );

  const handleSearch = (value) => {
    if (tabIndex === 1) {
      debouncedSearchTab1(value);
    } else if (tabIndex === 2) {
      debouncedSearchTab2(value);
    }
  };

  const downloadFile = async (response) => {
    const blob = new Blob([response.data], { type: response.headers.get('content-type') });
    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.setAttribute('download', response.headers.get('content-disposition').split('"')[1]);
    downloadLink.click();
    window.URL.revokeObjectURL(url);
  }

  const getDematInvestors = async (params) => {
    setShowTableLoader(true);
    try {
      const res = await apiDematTableInvestors({
        sd: params?.dpType,
        oppRid: params?.oppRid,
        cmRid: params?.cmRid,
      });
      setDematInvestors(res);
      setShowTableLoader(false);
    } catch (error) {
      console.error("Error fetching demat data:", error);
      setShowTableLoader(false);
    }
  };
  const getCorpActionFileLog = (page = 1) => {
    const params = {
      page: page,
      limit: RECORD_DISPLAY_LIMIT,
    };

    setIsCorpActionLoading(true);
    apiGetCorpActionFileLog(params)
      .then((data) => {
        setIsCorpActionLoading(false);
        setCorpActionFileList(data.corpActionFileLogs || []);
        setTotalCorpActionRecords(data.records || 0);
      })
      .catch((e) => {
        setIsCorpActionLoading(false);
        enqueueSnackbar(e, SNACKBAR_ERROR);
      });
  };
  const handleCorpActionPageChange = (event, value) => {
    setCorpActionPage(value);
    getCorpActionFileLog(value);
  };
  useEffect(() => {
    if (tabIndex === 3) {
      getCorpActionFileLog(corpActionPage);
    }
  }, [tabIndex, corpActionPage]);
  const loadMoreSchemes = () => {
    if (!schemeListboxRef.current || schemeFilterLoading) return;
    const listBox = schemeListboxRef.current;
    const isAtBottom = listBox.scrollHeight - listBox.scrollTop <= listBox.clientHeight + 20;
    if (isAtBottom && hasMoreSchemes === "") {
      scrollPreservationRef.current = {
        position: listBox.scrollTop,
        isUpdating: true
      };
      setSchemeFilterLoading(true);
      const nextPage = schemePage + 1;
      setSchemePage(nextPage);
      getFilterSchemes(nextPage, true, schemeSearchTerm);
    }
  };

  const debouncedSchemeSearch = useCallback(
    _.debounce((searchValue) => {
      const input = schemeAutocompleteRef.current?.querySelector('input[role="combobox"]');
      const cursorPosition = input?.selectionStart || searchValue.length;
      schemeInputPositionRef.current = cursorPosition;
      setSchemeSearchTerm(searchValue);
      setSchemePage(1);
      setHasMoreSchemes("");
      getFilterSchemes(1, false, searchValue)
        .finally(() => {
          setTimeout(() => {
            const input = schemeAutocompleteRef.current?.querySelector('input[role="combobox"]');
            if (input) {
              input.focus();
              const position = schemeInputPositionRef.current || searchValue.length;
              input.setSelectionRange(position, position);
            }
          }, 10);
        });
    }, 300),
    [filterPartner]
  );
  const getFilterSchemes = async (page = 1, loadMore = false, searchTerm = "") => {
    if (schemeFilterLoading && !loadMore) return Promise.resolve();

    const params = {
      page: page,
      limit: 20,
      schemeStatus: `${OPEN_SCHEMES},${CLOSED_SCHEMES}`,
      schemeName: searchTerm,
      partnerRids: filterPartner.length > 0 ? filterPartner.join(",") : ""
    };
    if (
      !loadMore &&
      lastFilterSchemesParams.current &&
      JSON.stringify(params) === JSON.stringify(lastFilterSchemesParams.current)
    ) {
      return Promise.resolve();
    }
    lastFilterSchemesParams.current = params;
    if (!loadMore) {
      setSchemeFilterLoading(true);
    }
    try {
      const response = await getOpportunitySimple(params);
      if (response?.opportunityList && response.opportunityList.length > 0) {
        const schemes = response.opportunityList.map(opportunity => ({
          schemeRid: opportunity.oppRid,
          schemeName: opportunity.oppTitle
        }));

        if (loadMore) {
          setFilterSchemeList(prevList => {
            const allSchemes = [...prevList, ...schemes];
            const uniqueSchemes = Array.from(
              new Set(allSchemes.map(scheme => scheme.schemeRid))
            ).map(rid =>
              allSchemes.find(scheme => scheme.schemeRid === rid)
            );
            return uniqueSchemes.sort((a, b) => a.schemeName.localeCompare(b.schemeName));
          });
        } else {
          setFilterSchemeList(
            schemes.sort((a, b) => a.schemeName.localeCompare(b.schemeName))
          );
        }

        if (response.opportunityList.length < params.limit ||
          page * params.limit >= response.totalCount) {
          setHasMoreSchemes("true");
        } else {
          setHasMoreSchemes("");
        }
      } else {
        setHasMoreSchemes("true");
      }

      return Promise.resolve();
    } catch (error) {
      console.error("Error fetching filter schemes:", error);
      enqueueSnackbar(error, SNACKBAR_ERROR);
      return Promise.reject(error);
    } finally {
      setSchemeFilterLoading(false);
    }
  };
  useLayoutEffect(() => {
    if (schemeListboxRef.current && scrollPreservationRef.current.isUpdating && !schemeFilterLoading) {
      schemeListboxRef.current.scrollTop = scrollPreservationRef.current.position;
      scrollPreservationRef.current.isUpdating = false;
    }
  }, [filterSchemeList, schemeFilterLoading]);

  const DematStatusFilter = ({ filterDematStatus, setFilterDematStatus, isLoading, onStatusChange }) => {
    const getStatusColor = (status) => {
      switch (status) {
        case CREDITED:
          return '#2E7D32';
        case PENDING:
          return '#FF7518';
        case ESCROW:
          return '#b71c1c';
        default:
          return '#00000000';
      }
    };

    const handleChange = (event) => {
      const newStatus = event.target.value;
      setPage(1);
      setFilterDematStatus(newStatus);
      if (onStatusChange) {
        onStatusChange(newStatus);
      }
    };

    return (
      <FormControl sx={{ width: 150 }} size="small">
        <InputLabel id="demat-status-select-label">Demat Status</InputLabel>
        <Select
          labelId="demat-status-select-label"
          id="demat-status-select"
          value={filterDematStatus}
          label="Demat Status"
          onChange={handleChange}
          disabled={isLoading}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {(selected === CREDITED || selected === PENDING || selected === ESCROW) && (
                <FiberManualRecordIcon
                  sx={{
                    fontSize: 15,
                    color: getStatusColor(selected)
                  }}
                />
              )}
              <Typography variant="body2">
                {selected === CREDITED ? 'Credited' :
                  selected === PENDING ? 'Pending' :
                    selected === ESCROW ? 'Escrow' : 'All'}
              </Typography>
            </Box>
          )}
        >
          <MenuItem value="all">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2">All</Typography>
            </Box>
          </MenuItem>
          <MenuItem value={CREDITED}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: 14, color: '#2E7D32' }} />
              <Typography variant="body2">Credited</Typography>
            </Box>
          </MenuItem>
          <MenuItem value={PENDING}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: 14, color: '#FF7518' }} />
              <Typography variant="body2">Pending</Typography>
            </Box>
          </MenuItem>
          <MenuItem value={ESCROW}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: 14, color: '#b71c1c' }} />
              <Typography variant="body2">Escrow</Typography>
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  const IsInStatusFilter = ({ isinStatus, setIsInStatus, isLoading, onStatusChange, setPage }) => {

    const getStatusColor = (status) => {
      switch (status) {
        case GENERATED:
          return '#2E7D32';
        case PENDING:
          return '#FF7518';
        default:
          return '#00000000';
      }
    };

    const handleChange = (event) => {
      const newStatus = event.target.value.toUpperCase();
      if (newStatus === "All") {
        setPage(1);
        setIsInStatus(newStatus);
      }
      setPage(1);
      setIsInStatus(newStatus);
      if (onStatusChange) {
        onStatusChange(newStatus);
      }
    };

    const getLabel = (status) => {
      switch (status) {
        case GENERATED:
          return 'Generated';
        case PENDING:
          return 'Pending';
        default:
          return 'All';
      }
    };

    return (
      <FormControl sx={{ width: "200px", position: "relative" }} size="large">
        <InputLabel id="demat-status-select-label">ISIN Status</InputLabel>
        <Select
          labelId="demat-status-select-label"
          id="demat-status-select"
          value={isinStatus}
          label="ISIN Status"
          onChange={handleChange}
          disabled={isLoading}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {(selected === GENERATED || selected === PENDING) && (
                <FiberManualRecordIcon
                  sx={{
                    fontSize: 15,
                    color: getStatusColor(selected)
                  }}
                />
              )}
              <Typography variant="body2">{getLabel(selected)}</Typography>
            </Box>
          )}
        >
          <MenuItem value="ALL">
            <Typography variant="body2">All</Typography>
          </MenuItem>
          <MenuItem value={GENERATED}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: 14, color: '#2E7D32' }} />
              <Typography variant="body2">Generated</Typography>
            </Box>
          </MenuItem>
          <MenuItem value={PENDING}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: 14, color: '#FF7518' }} />
              <Typography variant="body2">Pending</Typography>
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  const getDematList = async () => {
    const params = {
      page,
      limit: RECORD_DISPLAY_LIMIT
    };
    setIsLoading(true);
    try {
      const data = await getDematMasterTable(params);
      setDematList(data.tableColumn);
      setDematDataList(data.tableData);
      if (typeof data.records === 'number') {
        setTotalRecords(data.records);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching demat data:", error);
      enqueueSnackbar(error, SNACKBAR_ERROR);
      setTotalRecords(0);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getIsinDetails = async () => {
      const params = {
        page,
        limit: RECORD_DISPLAY_LIMIT,
        isinStatus: isInStatus === 'ALL' ? null : isInStatus,
        schemeRids: filterIsinScheme.length > 0 ? filterIsinScheme.join(",") : "",
        schemeName: isinSearchTerm || "",
      };

      setIsLoading(true);

      try {
        const response = await apiGetIsinDetails(params);

        setIsInList(response.isinList);

        if (page === 1) {
          setTotalIsinRecords(response.records);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    getIsinDetails();
  }, [isInStatus, page, filterIsinScheme, isinSearchTerm]);

  const getDematHoldings = async () => {
    const params = {
      page: page,
      limit: RECORD_DISPLAY_LIMIT,
      invName: searchTerm,
      partnerRids: filterPartner.length > 0 ? filterPartner.join(",") : "",
      schemeRids: filterScheme.length > 0 ? filterScheme.join(",") : "",
      dematStatus: filterDematStatus !== "all" ? filterDematStatus : "",
    };
    if (
      lastDematHoldingsParams.current &&
      JSON.stringify(params) === JSON.stringify(lastDematHoldingsParams.current)
    ) {
      return;
    }
    lastDematHoldingsParams.current = params;
    setIsLoading(true);
    try {
      const response = await apiGetDematHoldings(params);
      setHoldingsList(response.holdingsList);

      if (page === 1 && typeof response.records === "number") {
        setTotalRecords(response.records);
      }
    } catch (error) {
      enqueueSnackbar(error, SNACKBAR_ERROR);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSchemeFilterChange = (event) => {
    const newFilters = event.target.value;
    setPage(1);
    setFilterScheme(newFilters);
    setPersistentSchemeFilters(newFilters);
  };

  const handlePageChange = (_event, value) => {
    setPage(value);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const downloadDematHoldings = () => {
    const params = {
      invName: searchTerm && searchTerm.trim() !== "" ? searchTerm.trim() : "",
      partnerRids: filterPartner.length > 0 ? filterPartner.join(",") : null,
      schemeRids: filterScheme.length > 0 ? filterScheme.join(",") : null,
      dematStatus: filterDematStatus !== "all" ? filterDematStatus : "",
    };

    apiDematHoldingsDownload(params)
      .then((data) => {
        downloadFile(data);
      })
      .catch((error) => {
        enqueueSnackbar(error, SNACKBAR_ERROR);
      });
  };

  const displayTableValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return '---';
    }
    return value;
  };

  const formatNumber = (number) => {
    if (number === null || number === undefined) {
      return '---';
    }
    return number.toLocaleString() || '---';
  };

  const getPartnersList = useCallback(() => {
    setPartnerList([]);
    getPartners()
      .then((res) => {
        setPartnerList(res.partnerMasterList);
      })
      .catch((e) => {
        enqueueSnackbar(e, SNACKBAR_ERROR);
      });
  }, [enqueueSnackbar]);

  useEffect(() => {
    getPartnersList();
  }, [getPartnersList]);

  useEffect(() => {
    if (tabIndex === 0) {
      getDematList();
    } else if (tabIndex === 1) {
      setInitialTabLoad(true);
      getFilterSchemes(1, false, schemeSearchTerm);
      getDematHoldings();
      setPage(1);
      setSchemePage(1);
      setHasMoreSchemes("");
    } else if (tabIndex === 2) {
      getFilterSchemes(1, false, schemeSearchTerm);
      setPage(1);
    }
  }, [tabIndex]);

  useEffect(() => {
    if (tabIndex === 1 && !initialTabLoad) {
      setSchemePage(1);
      setHasMoreSchemes("");
      getFilterSchemes(1, false, schemeSearchTerm);
    }
    if (initialTabLoad && tabIndex === 1) {
      setInitialTabLoad(false);
    }
  }, [tabIndex, filterPartner, initialTabLoad]);

  useEffect(() => {

    if (tabIndex === 1 && page > 1) {

      getDematHoldings();

    }

  }, [tabIndex, page]);

  useEffect(() => {
    if (tabIndex === 0) {
      getDematList();
    } else if (tabIndex === 1) {
      setInitialTabLoad(true);
      setPage(1);
      setSchemePage(1);
      setHasMoreSchemes("");
      getFilterSchemes(1, false, schemeSearchTerm)
        .then(() => {
          if (!lastDematHoldingsParams.current) {
            getDematHoldings();
          }
        });
    } else if (tabIndex === 2) {
      setInitialTabLoad(true);
      setPage(1);
      setSchemePage(1);
      setHasMoreSchemes("");
      getFilterSchemes(1, false, schemeSearchTerm)
    }
  }, [tabIndex]);
  useEffect(() => {
    if (tabIndex === 1 && !initialTabLoad) {
      const params = {
        page: page,
        limit: RECORD_DISPLAY_LIMIT,
        invName: searchTerm,
        partnerRids: filterPartner.length > 0 ? filterPartner.join(",") : "",
        schemeRids: filterScheme.length > 0 ? filterScheme.join(",") : "",
        dematStatus: filterDematStatus !== "all" ? filterDematStatus : "",
      };
      if (
        lastDematHoldingsParams.current &&
        JSON.stringify(params) === JSON.stringify(lastDematHoldingsParams.current)
      ) {
        return;
      }

      setPage(1);
      getDematHoldings();
    }
    if (tabIndex === 2) {
      setPage(1);
    }

    if (initialTabLoad && tabIndex === 1) {
      setInitialTabLoad(false);
    }
  }, [tabIndex, filterPartner, isinSearchTerm, isInStatus, filterScheme, filterScheme, filterDematStatus, searchTerm, initialTabLoad]);

  useEffect(() => {
    getIsinFilterSchemes();
  }, [tabIndex]);

  const getIsinFilterSchemes = async () => {
    try {
      const initialParams = {
        page: 1,
        limit: 2000,
        schemeStatus: `${OPEN_SCHEMES},${CLOSED_SCHEMES}`,
        schemeName: ''
      };

      const initialResponse = await getOpportunitySimple(initialParams);
      let allSchemes = [];

      if (initialResponse?.opportunityList) {
        allSchemes = initialResponse.opportunityList.map(opportunity => ({
          schemeRid: opportunity.oppRid,
          schemeName: opportunity.oppTitle
        }));

        if (initialResponse.totalCount > 2000) {
          const remainingPages = Math.ceil((initialResponse.totalCount - 2000) / 2000);
          const additionalRequests = Array.from({ length: remainingPages }, (_, i) => i + 2)
            .map(page => getOpportunitySimple({
              page,
              limit: 2000,
              schemeStatus: '',
              schemeName: ''
            }));

          const additionalResponses = await Promise.all(additionalRequests);
          additionalResponses.forEach(response => {
            if (response?.opportunityList) {
              allSchemes = [...allSchemes,
              ...response.opportunityList.map(opportunity => ({
                schemeRid: opportunity.oppRid,
                schemeName: opportunity.oppTitle
              }))
              ];
            }
          });
        }

        allSchemes.sort((a, b) => a.schemeName.localeCompare(b.schemeName));
        setFilterIsinSchemeList(allSchemes);
      }
    } catch (error) {
      enqueueSnackbar(error, SNACKBAR_ERROR);
    }
  };

  useEffect(() => {
    if (tabIndex === 1 && !initialTabLoad && filterPartner.length > 0) {
      const params = {
        page: 1,
        limit: 20,
        schemeStatus: `${OPEN_SCHEMES},${CLOSED_SCHEMES}`,
        schemeName: schemeSearchTerm,
        partnerRids: filterPartner.length > 0 ? filterPartner.join(",") : ""
      };
      if (
        lastFilterSchemesParams.current &&
        JSON.stringify(params) === JSON.stringify(lastFilterSchemesParams.current)
      ) {
        return;
      }

      setSchemePage(1);
      setHasMoreSchemes("");
      getFilterSchemes(1, false, schemeSearchTerm);
    }
  }, [tabIndex, filterPartner, initialTabLoad]);
  useEffect(() => {
    if (tabIndex === 1 && page > 1) {
      getDematHoldings();
    }
  }, [tabIndex, page]);
  const styles = {
    stickyColumn: {
      position: "sticky",
      left: 0,
      zIndex: 1,
    },
    stickyTop: {
      position: "sticky",
      top: 0,
      zIndex: 2,
    },
    stickyColumn2: {
      position: "sticky",
      left: "250px",
      zIndex: 1,
    },
    stickyColumn3: {
      position: "sticky",
      left: "400px",
      zIndex: 1,
    },
  };
  const renderTableContent = () => {
    if (tabIndex === 0) {
      return (
        <div className="overflow-x-scroll">
          {dematList?.length > 0 ? (
            <table
              className="table table-striped table-borderless w-100 position-relative"
              id="order-table"
            >
              <thead>
                <tr className="fs-normal-semibold text-center sticky-table-row">
                  <th
                    className="sticky-table-cell"
                    scope="col"
                    style={{ minWidth: "250px" }}
                  >
                    <p className="m-0">Scheme Names</p>
                  </th>
                  {dematList.map((item, key) => (
                    <th
                      key={key}
                      scope="col"
                      style={{ minWidth: "150px" }}
                      className="text-center"
                    >
                      <p
                        className={`${item.dpType === "ESCROW" ? "text-danger" : ""
                          } m-0`}
                      >
                        {item.name} {item.dpType}
                      </p>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-table-blue">
                {dematDataList.map((data, index) => (
                  <tr key={index} className="fs-normal-medium text-center">
                    <td className="sticky-table-cell">{data.schemeName}</td>
                    {data.cells.map((cellData, cellIndex) => (
                      <td className="text-center" key={cellIndex}>
                        {cellData?.dpType === null ? (
                          <span>-</span>
                        ) : cellData?.value === 0 ? (
                          <span
                            className={`${cellData.dpType === "ESCROW" ? "text-danger" : ""
                              }`}
                          >
                            {cellData.value}
                          </span>
                        ) : (
                          <CustomTooltip
                            title={
                              <DematInvestors
                                dematInvestorList={dematInvestors}
                                showTableLoading={showTableLoader}
                              />
                            }
                            arrow
                          >
                            <span
                              className={`${cellData.dpType === "ESCROW"
                                ? "text-danger"
                                : ""
                                }`}
                              style={{ cursor: "pointer" }}
                              onMouseEnter={() => getDematInvestors(cellData)}
                            >
                              {cellData.value}
                            </span>
                          </CustomTooltip>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No Data..</p>
          )}
        </div>
      );
    }

    if (tabIndex === 1) {
      return (
        <div className="d-flex overflow-x-auto">
          {!Array.isArray(holdingsList) || holdingsList.length === 0 ? (
            <p>No Data..</p>
          ) : (
            <table
              className="table table-borderless w-auto"
              id="order-table"
            >
              <thead>
                <tr
                  className="fs-normal-semibold text-center"
                  style={styles.stickyTop}
                >
                  <th
                    className="sticky-column"
                    style={{ ...styles.stickyColumn }}
                  >
                    <p className="m-0">Investor Name</p>
                  </th>
                  <th
                    className="sticky-column"
                    style={{ ...styles.stickyColumn2 }}
                  >
                    <p className="m-0">DP ID</p>
                  </th>
                  <th
                    className="sticky-column"
                    style={{ ...styles.stickyColumn3 }}
                  >
                    <p className="m-0">Client ID</p>
                  </th>
                  <th scope="col">
                    <p className="m-0">Scheme Name</p>
                  </th>
                  <th scope="col">
                    <p className="m-0">Class</p>
                  </th>
                  <th scope="col">
                    <p className="m-0">No of Units</p>
                  </th>
                  <th scope="col">
                    <p className="m-0">Demat Status</p>
                  </th>
                </tr>
              </thead>
              <tbody className="bg-table-blue">
                {holdingsList.map((investor, investorIndex) => {
                  const previousRows = holdingsList
                    .slice(0, investorIndex)
                    .reduce((sum, inv) => sum + inv.dematDetailList.length, 0);

                  return (
                    <React.Fragment key={investor.invRid}>
                      {investor.dematDetailList.map((detail, detailIndex) => {
                        const absoluteRowIndex = previousRows + detailIndex;
                        const stripeBackground = absoluteRowIndex % 2 === 0 ? '#F2F2F2' : '#ffffff';
                        const isLastDetailRow = detailIndex === investor.dematDetailList.length - 1;

                        return (
                          <tr
                            key={`${investor.invRid}-${detailIndex}`}
                            className="fs-normal-medium text-center"
                            style={{
                              borderBottom: isLastDetailRow ? '1.5px solid #e0e0e0' : 'none'
                            }}
                          >
                            {detailIndex === 0 && (
                              <>
                                <td
                                  className="sticky-column"
                                  style={{
                                    ...styles.stickyColumn,
                                    minWidth: "250px",
                                    backgroundColor: investorIndex % 2 === 0 ? '#F2F2F2' : '#ffffff',
                                    verticalAlign: 'middle'
                                  }}
                                  rowSpan={investor.dematDetailList.length}
                                >
                                  <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'flex-start',
                                    gap: '4px'
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      alignItems: 'baseline',
                                      maxWidth: '100%'
                                    }}>
                                      <span style={{
                                        marginRight: '8px',
                                        wordBreak: 'break-word'
                                      }}>
                                        {displayTableValue(investor.invName)}
                                      </span>
                                      <span style={{
                                        fontSize: '10px',
                                        color: '#666666',
                                        flexShrink: 0,
                                        alignSelf: 'flex-start',
                                        marginTop: '4px'
                                      }}>
                                        {investor.invCode}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td
                                  className="sticky-column"
                                  style={{
                                    ...styles.stickyColumn2,
                                    minWidth: "150px",
                                    backgroundColor: investorIndex % 2 === 0 ? '#F2F2F2' : '#ffffff',
                                    verticalAlign: 'middle'

                                  }}
                                  rowSpan={investor.dematDetailList.length}
                                >
                                  {displayTableValue(investor.dpId)}
                                </td>
                                <td
                                  className="sticky-column"
                                  style={{
                                    ...styles.stickyColumn3,
                                    minWidth: "150px",
                                    backgroundColor: investorIndex % 2 === 0 ? '#F2F2F2' : '#ffffff',
                                    verticalAlign: "middle"

                                  }}
                                  rowSpan={investor.dematDetailList.length}
                                >
                                  {displayTableValue(investor.clientId)}
                                </td>
                              </>
                            )}
                            <td style={{ minWidth: "200px", backgroundColor: stripeBackground }}>
                              {displayTableValue(detail.schemeName)}
                            </td>
                            <td style={{ minWidth: "150px", backgroundColor: stripeBackground }}>
                              {displayTableValue(detail.className)}
                            </td>
                            <td style={{ minWidth: "150px", textAlign: "center", backgroundColor: stripeBackground }}>
                              {formatNumber(detail.noOfUnits)}
                            </td>
                            <td style={{ minWidth: "200px", backgroundColor: stripeBackground }}>
                              {detail.dematStatus === ESCROW ? (
                                <Chip
                                  label="ESCROW"
                                  size="small"
                                  sx={{
                                    backgroundColor: "#d32f2f",
                                    color: "white",
                                    borderColor: "#b71c1c",
                                    fontWeight: "medium",
                                    "& .MuiChip-label": {
                                      color: "white"
                                    }
                                  }}
                                />
                              ) : (
                                <Chip
                                  label={detail.dematStatus}
                                  size="small"
                                  color={
                                    detail.dematStatus === "Credited"
                                      ? "success"
                                      : "warning"
                                  }
                                  variant="outlined"
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      );
    }
    if (tabIndex === 2) {
      const styles = {
        stickyTop: {
          position: 'sticky',
          top: 0,
          background: '#fff',
          zIndex: 8,
          height: "39px"
        },
        stickyTopSecond: {
          position: 'sticky',
          top: 39,
          background: '#fff',
          zIndex: 5,
        },
        stickyColumn: {
          position: 'sticky',
          left: 0,
          background: '#fff',
          zIndex: 3,
        },
      };

      return (
        <div className="d-flex" style={{ overflowX: 'auto' }}>
          {!Array.isArray(isInList) || isInList.length === 0 ? (
            <p>No Data..</p>
          ) : (
            <div style={{ maxHeight: '500px', overflowY: 'auto', width: 'max-content' }}>
              <table className="table table-borderless w-auto" id="order-table">
                <thead>
                  <tr className="fs-normal-semibold text-center" style={styles.stickyTop}>
                    <th className="sticky-column" style={styles.stickyColumn}>
                      <p className="m-0">Scheme Names</p>
                    </th>
                    <th style={{ position: "relative" }}>
                      <p className="m-0" style={{ width: "100%", whiteSpace: "nowrap" }}>Class Name</p>
                    </th>
                    <th colSpan={2} style={{ paddingLeft: "0rem", paddingRight: "0rem", position: "relative", }}>
                      <p style={{ marginBlockStart: "0px", marginBlockEnd: "0px", textAlign: "center" }}>ISIN</p>
                    </th>
                    <th colSpan={2} style={{ paddingLeft: "0rem", paddingRight: "0rem", position: "relative", }}>
                      <p style={{ marginBlockStart: "0px", marginBlockEnd: "0px", textAlign: "center" }}>ISIN Description</p>
                    </th>
                    <th>
                      <p className="m-0" style={{ textAlign: "center" }}>ISIN Status</p>
                    </th>
                  </tr>
                  <tr className="fs-normal-semibold text-center" style={styles.stickyTopSecond}>
                    {Array(7).fill(null).map((_, i) => (
                      <th
                        key={i}
                        style={{
                          top: 0,
                          position: 'sticky',
                          background: '#fff',
                          zIndex: 5,
                          position: 'relative'
                        }}
                      >
                        {i >= 2 && i <= 5 ? (
                          <p className="m-0" style={{
                            textAlign: i <= 3 ? 'center' : 'left'
                          }}>
                            {["NSDL ISIN", "CDSL ISIN", "NSDL Description", "CDSL Description"][i - 2]}</p>
                        ) : null}
                      </th>
                    ))}

                  </tr>
                </thead>
                <tbody className="bg-table-blue">
                  {isInList.map((data, index) => {
                    const previousRows = isInList
                      .slice(0, index)
                      .reduce((sum, item) => sum + item.isinDetails.length, 0);

                    return (
                      <React.Fragment key={index}>
                        {data.isinDetails.map((isinDetail, subIndex) => {
                          const absoluteRowIndex = previousRows + subIndex;
                          const stripeBackground = absoluteRowIndex % 2 === 0 ? '#F2F2F2' : '#ffffff';
                          const isLastDetailRow = subIndex === data.isinDetails.length - 1;

                          return (
                            <tr
                              key={`${index}-${subIndex}`}
                              className="fs-normal-medium text-center"
                              style={{
                                borderBottom: isLastDetailRow ? '1.5px solid #e0e0e0' : 'none'
                              }}
                            >
                              {subIndex === 0 && (
                                <>
                                  <td
                                    className="sticky-column"
                                    style={{
                                      ...styles.stickyColumn,
                                      minWidth: "250px",
                                      backgroundColor: index % 2 === 0 ? '#F2F2F2' : '#ffffff',
                                      verticalAlign: 'middle'
                                    }}
                                    rowSpan={data.isinDetails.length}
                                  >
                                    <div style={{
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      alignItems: 'flex-start',
                                      gap: '4px'
                                    }}>
                                      <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'baseline',
                                        maxWidth: '100%'
                                      }}>
                                        <span style={{
                                          marginRight: '8px',
                                          wordBreak: 'break-word'
                                        }}>
                                          {data.oppTitle || '---'}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                </>
                              )}
                              <td style={{
                                flex: 1,
                                backgroundColor: stripeBackground,
                                verticalAlign: 'middle',
                                position: 'relative',
                                whiteSpace: 'nowrap'
                              }}>
                                {isinDetail.className || "---"}
                              </td>

                              <td style={{ width: "150px", backgroundColor: stripeBackground, verticalAlign: 'middle', textAlign: "center", position: 'relative' }}>
                                {isinDetail.nsdlIsin || "---"}
                              </td>
                              <td style={{ minWidth: "150px", backgroundColor: stripeBackground, verticalAlign: 'middle', textAlign: "center", position: 'relative' }}>
                                {isinDetail.cdslIsin || "---"}
                              </td>
                              <td style={{ minWidth: "250px", backgroundColor: stripeBackground }}>
                                {isinDetail.nsdlIsinDescription || "---"}
                              </td>
                              <td style={{ minWidth: "250px", backgroundColor: stripeBackground }}>
                                {isinDetail.cdslIsinDescription || "---"}
                              </td>
                              <td style={{ minWidth: "150px", backgroundColor: stripeBackground, verticalAlign: 'middle', textAlign: "center", position: 'relative' }}>
                                <Chip
                                  label={isinDetail.isinStatus || "---"}
                                  size="small"
                                  color={
                                    isinDetail.isinStatus === "Pending"
                                      ? "success"
                                      : isinDetail.isinStatus === "GENERATED"
                                        ? "default"
                                        : "warning"
                                  }
                                  variant="outlined"
                                  sx={
                                    isinDetail.isinStatus === "GENERATED"
                                      ? {
                                        backgroundColor: "transparent",
                                        color: "green",
                                        borderColor: "green",
                                        fontWeight: "medium",
                                        "& .MuiChip-label": { color: "green" }
                                      }
                                      : {}
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>

              </table>

            </div>
          )}
        </div>
      );

    }

    if (tabIndex === 3) {
      return (
        <div
          className="bg-white d-flex flex-column"
          style={{
            borderRadius: '0 0 5px 5px',
            height: 'calc(100vh - 200px)',
            minHeight: '500px',
            width: '100%',
            margin: 0,
            padding: 0,
            position: 'relative'
          }}
        >
          <div className="d-flex justify-content-end align-items-center w-100 px-3 py-2 ">
            {!isCorpActionLoading && corpActionFileList.length > 0 && (
              <Pagination
                color="secondary"
                size="small"
                siblingCount={0}
                onChange={handleCorpActionPageChange}
                count={Math.max(1, totalCorpActionRecords > 0 ? Math.ceil(totalCorpActionRecords / RECORD_DISPLAY_LIMIT) : 1)}
                page={corpActionPage}
              />
            )}
          </div>
          <Button
            sx={{
              height: "64px",
              borderRadius: "50%",
              position: "fixed",
              bottom: "20px",
              right: "20px",
            }}
            onClick={toggleCorporateAction}
            variant="contained"
            aria-label="create corporate action"
            color="secondary"
          ><AddIcon /></Button>

          {/* Content area */}
          {isCorpActionLoading ? (
            <div className="flex-grow-1 d-flex flex-column justify-content-start w-100 px-3">
              {[...Array(RECORD_DISPLAY_LIMIT)].map((_, index) => (
                <Skeleton
                  animation="wave"
                  key={index}
                  style={{ marginBottom: 6, width: '100%' }}
                  variant="rectangle"
                  height={40}
                />
              ))}
            </div>
          ) : (
            <div className="d-flex flex-column flex-grow-1 w-100">
              {corpActionFileList.length > 0 ? (
                <div
                  className="w-100 flex-grow-1"
                  style={{
                    overflowY: 'auto',
                    overflowX: 'auto',
                    width: '100%',
                    padding: '0'
                  }}
                >
                  <table
                    className="table table-striped table-borderless"
                    style={{
                      width: '100%',
                      tableLayout: 'fixed',
                      margin: 0
                    }}
                  >
                    <thead>
                      <tr className="fs-normal-semibold text-center sticky-top bg-white">
                        <th style={{ width: '25%', textAlign: 'center' }}>
                          <p className="m-0 text-center">Reference Number</p>
                        </th>
                        <th style={{ width: '20%', textAlign: 'center' }}>
                          <p className="m-0 text-center">Date</p>
                        </th>
                        <th style={{ width: '17.5%', textAlign: 'center' }}>
                          <p className="m-0 text-center">Excel</p>
                        </th>
                        <th style={{ width: '17.5%', textAlign: 'center' }}>
                          <p className="m-0 text-center">Word</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-table-blue">
                      {corpActionFileList.map((item, index) => {
                        // Format date to DD-MM-YYYY
                        const formatDate = (dateStr) => {
                          if (!dateStr) return "--";
                          const date = new Date(dateStr);
                          const day = date.getDate().toString().padStart(2, '0');
                          const month = (date.getMonth() + 1).toString().padStart(2, '0');
                          const year = date.getFullYear();
                          return `${day}-${month}-${year}`;
                        };

                        return (
                          <tr className="fs-normal-medium text-center" key={index}>
                            <td className="pt-3 text-center">{item.referenceNumber || "--"}</td>
                            <td className="pt-3 text-center">
                              {item.date ? formatDate(item.date) : "--"}
                            </td>
                            <td className="pt-3 text-center">
                              {item.corpActionFile && item.corpActionFile.length > 0 && item.corpActionFile.some(file => file.contentType.includes('excel')) ? (
                                <Link
                                  color="secondary"
                                  target="_blank"
                                  href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(BASE_URL + '/' + item.corpActionFile.find(file => file.contentType.includes('excel')).path)}`}
                                >
                                  View
                                </Link>
                              ) : "--"}
                            </td>
                            <td className="pt-3 text-center">
                              {item.corpActionFile && item.corpActionFile.length > 0 && item.corpActionFile.some(file => file.contentType.includes('docx')) ? (
                                <Link
                                  color="secondary"
                                  target="_blank"
                                  href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(BASE_URL + '/' + item.corpActionFile.find(file => file.contentType.includes('docx')).path)}`}
                                >
                                  View
                                </Link>
                              ) : "--"}
                            </td>
                          </tr>
                        );
                      })}
                      {corpActionFileList.length < 10 && (
                        [...Array(10 - corpActionFileList.length)].map((_, index) => (
                          <tr key={`empty-${index}`} style={{ height: '52px' }}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-grow-1">
                  <p>No Data...</p>
                </div>
              )}
            </div>
          )}
        </div>
      );
    }
  }
  return (
    <Layout title="Demat">
      <div
        className="d-flex flex-row justify-content-between bg-white mb-3 mt-3 m-lg-3"
        style={{ borderRadius: "4px" }}
      >
        {process.env.REACT_APP_USER_TYPE == "ADMIN" ? (
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="DEMAT MASTER" />
            <Tab label="DEMAT HOLDINGS" />
            <Tab label="ISINs" />
            <Tab label="CORPORATE ACTION" />
          </Tabs>) : <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
          <Tab label="DEMAT MASTER" />
          <Tab label="DEMAT HOLDINGS" />
        </Tabs>}
      </div>

      <Divider style={{ height: "1px", backgroundColor: "#000" }} />
      {tabIndex === 1 && (
        <div
          className="d-flex flex-row justify-content-between bg-white p-3 mb-4"
          style={{ borderRadius: "5px" }}
        >
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <div
              className="search-input-btn d-flex flex-row justify-content-between rounded bg-white px-3"
              style={{
                border: "1px solid #000",
                minWidth: "200px",
                flex: "1 1 auto",
              }}
            >
              <div className="my-auto">
                <SearchIcon sx={{ cursor: "pointer" }} />
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                className="form-control custom-form-control border-0 bg-transparent fs-large-regular"
                placeholder="Search"
              />
              <div onClick={() => setSearchTerm("")} className="my-auto">
                <CloseIcon sx={{ cursor: "pointer" }} />
              </div>
            </div>
            <div className="d-flex gap-2 flex-wrap">

              {userType === "ADMIN" && (
                <FormControl
                  sx={{
                    width: { xs: "100%", sm: 180 },
                    minWidth: "180px",
                    "@media (max-width: 600px)": {
                      width: "100%",
                    },
                  }}
                  size="small"
                >
                  <Autocomplete
                    multiple
                    id="partner-filter-autocomplete"
                    options={partnerList}
                    getOptionLabel={(option) => option.fullName}
                    value={partnerList.filter(partner => filterPartner.includes(partner.partnerRid))}
                    onKeyDown={(event) => {
                      if (event.key === 'Backspace') {
                        event.stopPropagation();
                      }
                    }}

                    onChange={(event, newValue) => {
                      if (event.type === 'click') {
                        const newPartnerRids = newValue.map(item => item.partnerRid);
                        setPage(1);
                        if (JSON.stringify(newPartnerRids) !== JSON.stringify(filterPartner)) {
                          setFilterScheme([]);
                          setPersistentSchemeFilters([]);
                          setSchemeSearchTerm("");
                          setSchemePage(1);
                          setHasMoreSchemes("");
                        }
                        setFilterPartner(newPartnerRids);
                      }
                    }}
                    renderInput={(params) => {
                      const isSearching = params.inputProps.value !== '';
                      return (
                        <TextField
                          {...params}
                          label="Filter By Partner"
                          size="small"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            sx: { '& .MuiAutocomplete-tag': { display: 'none' } },
                            endAdornment: (
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                position: 'relative',
                                width: '100%',
                                justifyContent: 'center'
                              }}>
                                {filterPartner.length > 0 && !isSearching ? (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      right: 0,
                                      left: 0,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      height: '100%',
                                      cursor: 'pointer',
                                      padding: '0 32px 0 8px',
                                      paddingRight: '24px',
                                      paddingBottom: '24px'
                                    }}
                                    onClick={(e) => {
                                      const dropdownButton = e.currentTarget.closest('.MuiAutocomplete-root').querySelector('.MuiAutocomplete-popupIndicator');
                                      if (dropdownButton) {
                                        dropdownButton.click();
                                      }
                                    }}
                                  >
                                    <div className="selected-count" style={{
                                      fontSize: '16px',
                                      color: 'rgba(0, 0, 0, 0.87)',
                                      whiteSpace: 'nowrap',
                                      display: 'flex',
                                      alignItems: 'center',
                                      transition: 'opacity 0.2s ease',
                                      pointerEvents: 'none'
                                    }}>
                                      {filterPartner.length} Selected
                                    </div>
                                    <div style={{
                                      position: 'absolute',
                                      right: 0,
                                      display: 'flex',
                                      alignItems: 'center',
                                      height: '100%',
                                      paddingBottom: '2px'
                                    }}>
                                      {params.InputProps.endAdornment}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )
                          }}
                        />
                      );
                    }}
                    renderOption={(props, option) => (
                      <div {...props} className="d-flex align-items-center" style={{
                        padding: '8px 16px',
                        cursor: 'pointer'
                      }}>
                        <Checkbox
                          checked={filterPartner.indexOf(option.partnerRid) > -1}
                          size="small"
                          sx={{
                            color: 'rgba(0, 0, 0, 0.54)',
                            '&.Mui-checked': {
                              color: 'primary.main'
                            }
                          }}
                        />
                        <div className="flex-grow-1" style={{ marginLeft: '8px' }}>
                          <span className="fs-med-medium">{option.fullName}</span>
                        </div>
                      </div>
                    )}
                    sx={{
                      width: { xs: "100%", sm: 180 },
                      minWidth: "180px",
                      "@media (max-width: 600px)": {
                        width: "100%"
                      },
                      '& .MuiAutocomplete-tag': {
                        display: 'none'
                      },
                      '& .MuiAutocomplete-paper': {
                        marginTop: '4px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                      },
                      '& .MuiAutocomplete-inputRoot': {
                        paddingRight: '8px !important'
                      }
                    }}
                    disableCloseOnSelect
                    disableClearable
                  />
                </FormControl>
              )}
              <FormControl
                sx={{
                  width: { xs: "100%", sm: 180 },
                  minWidth: "180px",
                  "@media (max-width: 600px)": {
                    width: "100%",
                  },
                }}
                size="small"
              >
                <Autocomplete
                  ref={schemeAutocompleteRef}
                  multiple
                  id="scheme-filter-autocomplete"
                  options={filterSchemeList}
                  ListboxComponent={(props) => {
                    return (
                      <ul
                        {...props}
                        ref={schemeListboxRef}
                        onScroll={hasMoreSchemes === "" ? loadMoreSchemes : undefined}
                        style={{
                          overflowY: "auto",
                          maxHeight: 320,
                          position: "relative",
                          paddingBottom: schemeFilterLoading ? "40px" : "0"
                        }}
                      >
                        {props.children}
                        {schemeFilterLoading && (
                          <div
                            ref={loaderRef}
                            style={{
                              position: "sticky",
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "8px 0",
                              backgroundColor: "#fff",
                              boxShadow: "0 -2px 5px rgba(0,0,0,0.05)",
                              zIndex: 1
                            }}
                          >
                            <CircularProgress size={24} />
                            <span style={{ marginLeft: 8, fontSize: 14 }}>Loading more schemes...</span>
                          </div>
                        )}
                      </ul>
                    );
                  }}
                  getOptionLabel={(option) => option.schemeName}
                  value={filterSchemeList.filter(scheme => filterScheme.includes(scheme.schemeRid))}
                  onKeyDown={(event) => {
                    if (event.key === 'Backspace') {
                      event.stopPropagation();
                    }
                  }}
                  onChange={(event, newValue, reason, details) => {
                    if (event.type === 'click') {
                      let newSchemeRids;
                      if (schemeSearchTerm) {
                        const targetSchemeRid = details?.option?.schemeRid;
                        if (targetSchemeRid) {
                          if (filterScheme.includes(targetSchemeRid)) {
                            newSchemeRids = filterScheme.filter(rid => rid !== targetSchemeRid);
                          } else {
                            newSchemeRids = [...filterScheme, targetSchemeRid];
                          }
                        } else {
                          newSchemeRids = newValue.map(item => item.schemeRid);
                        }
                      } else {
                        newSchemeRids = newValue.map(item => item.schemeRid);
                      }

                      handleSchemeFilterChange({ target: { value: newSchemeRids } });
                      if (JSON.stringify(newSchemeRids) !== JSON.stringify(filterScheme)) {
                        setPage(1);
                        getDematHoldings();
                      }
                    }
                  }}
                  onClose={(event, reason) => {
                    setSchemeSearchTerm('');
                    if (reason !== 'toggleInput') {
                      setSchemePage(1);
                      setHasMoreSchemes("");
                      getFilterSchemes(1, false, "");
                    }
                  }}
                  loading={schemeFilterLoading}
                  disabled={isLoading}
                  freeSolo={true}
                  inputValue={schemeSearchTerm}
                  onInputChange={(event, newValue, reason) => {
                    if (event && (reason === 'input' || reason === 'clear')) {
                      if (event.target) {
                        schemeInputPositionRef.current = event.target.selectionStart;
                      }
                      setSchemeSearchTerm(newValue);
                      if (newValue) {
                        setIsSearchingScheme(true);
                        debouncedSchemeSearch(newValue);
                      } else {
                        setIsSearchingScheme(false);
                      }
                    }
                  }}
                  filterOptions={(options, params) => {
                    return options;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Filter By Scheme"
                      size="small"
                      variant="outlined"
                      placeholder=""
                      InputLabelProps={{
                        shrink: filterScheme.length > 0 || params.InputLabelProps.focused,
                        style: filterScheme.length > 0 ? {
                          background: '#fff',
                          padding: '0 5px'
                        } : {}
                      }}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          '& .MuiAutocomplete-tag': { display: 'none' },
                        },
                        endAdornment: (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            position: 'relative',
                            width: '100%',
                            justifyContent: 'center'
                          }}>
                            {filterScheme.length > 0 && !schemeSearchTerm ? (
                              <div
                                style={{
                                  position: 'absolute',
                                  right: 0,
                                  left: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  height: '100%',
                                  cursor: 'pointer',
                                  padding: '0 32px 0 8px',
                                  paddingRight: '24px',
                                  paddingBottom: '0'
                                }}
                                onClick={(e) => {
                                  const dropdownButton = e.currentTarget.closest('.MuiAutocomplete-root').querySelector('.MuiAutocomplete-popupIndicator');
                                  if (dropdownButton) {
                                    dropdownButton.click();
                                  }
                                }}
                              >
                                <div className="selected-count" style={{
                                  fontSize: '16px',
                                  color: 'rgba(0, 0, 0, 0.87)',
                                  whiteSpace: 'nowrap',
                                  display: 'flex',
                                  alignItems: 'center',
                                  transition: 'opacity 0.2s ease',
                                  pointerEvents: 'none',
                                  marginLeft: '14px',
                                  position: 'absolute',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  marginTop: '-13px'
                                }}>
                                  {filterScheme.length} Selected
                                </div>
                                <div style={{
                                  position: 'absolute',
                                  right: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                  height: '100%'
                                }}>
                                  {params.InputProps.endAdornment}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        )
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <div {...props} className="d-flex align-items-center" style={{
                      padding: '8px 16px',
                      cursor: 'pointer'
                    }}>
                      <Checkbox
                        checked={filterScheme.indexOf(option.schemeRid) > -1 ||
                          persistentSchemeFilters.indexOf(option.schemeRid) > -1}
                        size="small"
                        sx={{
                          color: 'rgba(0, 0, 0, 0.54)',
                          '&.Mui-checked': {
                            color: 'primary.main'
                          }
                        }}
                      />
                      <div className="flex-grow-1" style={{ marginLeft: '8px' }}>
                        <span className="fs-med-medium">{option.schemeName}</span>
                      </div>
                    </div>
                  )}
                  sx={{
                    width: { xs: "100%", sm: 180 },
                    minWidth: "180px",
                    "@media (max-width: 600px)": {
                      width: "100%"
                    },
                    '& .MuiAutocomplete-tag': {
                      display: 'none'
                    },
                    '& .MuiAutocomplete-paper': {
                      marginTop: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    },
                    '& .MuiAutocomplete-inputRoot': {
                      paddingRight: '8px !important'
                    }
                  }}
                  disableCloseOnSelect
                  disableClearable
                />


              </FormControl>
              <DematStatusFilter
                filterDematStatus={filterDematStatus}
                setFilterDematStatus={setFilterDematStatus}
                isLoading={isLoading}
                onStatusChange={() => {
                  if (tabIndex === 1) {
                    getDematHoldings();
                  }
                }}
              />

              {!isSubAdmin() && (
                <Button
                  sx={{ textTransform: "none" }}
                  onClick={downloadDematHoldings}
                  startIcon={<GetAppIcon />}
                  disabled={isLoading}
                >
                  <span className="fs-med-regular">Export to Excel</span>
                </Button>
              )}
            </div>
            <div style={{ flex: 1, width: "900px" }}></div>
            <div className="ms-auto d-flex align-items-center">

              <Pagination
                color="secondary"
                size="small"
                siblingCount={0}
                onChange={handlePageChange}
                count={Math.max(1, totalRecords > 0 ? Math.ceil(totalRecords / RECORD_DISPLAY_LIMIT) : 1)}
                page={page}
              />
            </div>
          </div>
        </div>
      )}
      {tabIndex === 2 && (
        <div
          className="d-flex flex-row justify-content-between bg-white p-3 mb-4"
          style={{ borderRadius: "5px" }}
        >
          <div className="d-flex align-items-center gap-2 flex-wrap" >
            <div
              className="search-input-btn d-flex flex-row justify-content-between rounded bg-white px-3"
              style={{
                border: "1px solid #000",
                minWidth: "50px",
                height: "100%"
              }}
            >
              <div className="my-auto">
                <SearchIcon sx={{ cursor: "pointer" }} />
              </div>
              <input
                type="text"
                value={isinSearchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                className="form-control custom-form-control border-0 bg-transparent fs-large-regular"
                placeholder="Search"
              />
              <div onClick={() => setisinSearchTerm("")} className="my-auto">
                <CloseIcon sx={{ cursor: "pointer" }} />
              </div>
            </div>
            <div className="d-flex gap-2 flex-wrap" style={{ height: "100%" }}>
              <FormControl sx={{ width: "200px", position: "relative" }} size="large">
                <InputLabel id="scheme-filter-label">Filter By Scheme</InputLabel>
                <Select
                  labelId="scheme-filter-label"
                  id="scheme-filter"
                  multiple
                  value={filterIsinScheme || []}
                  onChange={(e) => {
                    setFilterIsinScheme(e.target.value)
                    setPage(1)
                  }
                  }
                  input={<OutlinedInput label="Filter By Scheme" />}
                  renderValue={(selected) => `${selected.length} selected`}
                >
                  {filterIsinSchemeList.map((scheme) => (
                    <MenuItem key={scheme.schemeRid} value={scheme.schemeRid}>
                      <Checkbox checked={filterIsinScheme?.includes(scheme.schemeRid)} />
                      <ListItemText primary={scheme.schemeName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <IsInStatusFilter
                isinStatus={isInStatus}
                setIsInStatus={setIsInStatus}
                isLoading={isLoading}
                setPage={setPage}
              />
            </div>
            <div style={{ flex: 1, width: "900px" }}></div>
            <div className="ms-auto d-flex align-items-center">

              <Pagination
                color="secondary"
                size="small"
                siblingCount={0}
                onChange={handlePageChange}
                count={Math.max(1, totalIsinRecords > 0 ? Math.ceil(totalIsinRecords / RECORD_DISPLAY_LIMIT) : 1)}
                page={page}
              />
            </div>
          </div>
        </div>
      )}
      <div className="d-flex flex-column bg-white overflow-hidden">
        <div
          className="d-flex flex-grow-1 bg-white px-3 overflow-y-scroll "
          style={{ borderRadius: "5px" }}
        >
          {isLoading
            ? [...Array(RECORD_DISPLAY_LIMIT)].map((_e, index) => (
              <Skeleton
                animation="wave"
                key={index}
                style={{ marginBottom: 6 }}
                variant="rectangle"
                height={40}
              />
            ))
            : renderTableContent()}
        </div>
      </div>
      <CorporateActionDialog
        open={openCorporateAction}
        toggleDialog={toggleCorporateAction}
      />
    </Layout>
  );
};

export default DematMaster;
